<template>
    <div class="row fill-height">
        <v-toolbar v-if="!loading" flat height="80" color="transparent" class="white--text">
            <div class="d-flex ml-1 mr-4">
                <v-img src="@/assets/images/avatar-placeholder.png" width="48" alt="avatar-placeholder"></v-img>
            </div>

            <div class="d-flex">
                <v-toolbar-title>
                    <div>{{ consult.patient.patient.full_name || consult.patient.patient.first_name || consult.patient.email || 'N⁄A' }}</div>
                    <div class="caption">{{ status }}</div>
                </v-toolbar-title>
            </div>
        </v-toolbar>
        
        <v-row v-if="loading" justify="center" align="center" class="fill-height black--text">
            <v-card color="transparent" class="text-center pa-2">
                <v-row justify="center" class="mb-4">
                    <div><v-img src="@/assets/images/avatar-placeholder.png" width="100"></v-img></div>
                </v-row>
                <h2 class="font-weight-bold mb-2">{{ consult.patient.patient.full_name || consult.patient.patient.first_name || consult.patient.email || 'N⁄A' }}</h2>
                <span>{{ status }}</span>
            </v-card>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'LoadingContent',
    props: ['loading', 'consult', 'status']
}
</script>